module.exports = __webpack_public_path__ + "media/images/back-arrow-0bb5864f4c762454c9c132946f432e6f.svg";